import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeachWaveComponent } from './beach-wave/beach-wave.component';
import { SkyDetailComponent } from './sky-detail/sky-detail.component';

@NgModule({
  declarations: [BeachWaveComponent,SkyDetailComponent],
  imports: [
    CommonModule
  ],exports:[BeachWaveComponent,SkyDetailComponent]
})
export class SharedModule { }
